<po-chart
  class="po-lg-6 po-md-6 po-mt-2"
  p-title="Vulnerabilidades (mês)"
  [p-options]="totalOptions"
  [p-categories]="categories"
  [p-series]="totalSeries"
  [p-type]="totalType"
/>

<po-chart
  class="po-lg-6 po-md-6 po-mt-2"
  p-title="Vulnerabilidades por criticidade (mês)"
  [p-options]="bySeverityOptions"
  [p-categories]="categories"
  [p-series]="bySeveritySeries"
  [p-type]="bySeverityType"
/>
